"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreInteractiveIcon = _interopRequireDefault(require("@vfuk/core-interactive-icon"));

var _coreAnimate = _interopRequireDefault(require("@vfuk/core-animate"));

var _coreIconButton = _interopRequireDefault(require("@vfuk/core-icon-button"));

var _coreTextInput = _interopRequireDefault(require("@vfuk/core-text-input"));

var Styled = _interopRequireWildcard(require("./styles/SearchTextInput.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SearchTextInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(SearchTextInput, _PureComponent);

  var _super = _createSuper(SearchTextInput);

  function SearchTextInput() {
    _classCallCheck(this, SearchTextInput);

    return _super.apply(this, arguments);
  }

  _createClass(SearchTextInput, [{
    key: "showClearButton",
    get: function get() {
      return !!(this.props.textInput.value && this.props.textInput.value.length);
    }
  }, {
    key: "clearButtonState",
    get: function get() {
      if (this.props.state === 'disabled' || this.props.state === 'loading') return 'disabled';
      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$searchIco;

      return /*#__PURE__*/_react["default"].createElement(Styled.SearchWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.SearchInput, null, /*#__PURE__*/_react["default"].createElement(Styled.Input, null, /*#__PURE__*/_react["default"].createElement(_coreTextInput["default"], {
        id: this.props.textInput.id,
        name: this.props.textInput.name,
        placeholder: this.props.textInput.placeholder,
        required: this.props.textInput.required,
        dataAttributes: this.props.textInput.dataAttributes,
        beforeChange: this.props.textInput.beforeChange,
        autoComplete: this.props.textInput.autoComplete,
        autoCapitalize: this.props.textInput.autoCapitalize,
        state: this.props.state,
        type: "search",
        onChange: this.props.textInput.onChange,
        value: this.props.textInput.value,
        describedBy: this.props.describedBy,
        domRef: this.props.textInput.domRef
      })), /*#__PURE__*/_react["default"].createElement(Styled.InteractionIcons, null, /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
        show: this.showClearButton,
        enter: {
          animations: ['fadeIn'],
          duration: 500
        },
        exit: {
          animations: ['fadeOut']
        }
      }, /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
        name: "close",
        srText: "".concat(this.props.t('Clear'), " ").concat(this.props.label.toLowerCase()),
        size: 2,
        onClick: this.props.onClear,
        state: this.clearButtonState
      })))), /*#__PURE__*/_react["default"].createElement(Styled.SearchIcon, {
        size: 4,
        hasState: this.props.state === 'error' || this.props.state === 'success'
      }, /*#__PURE__*/_react["default"].createElement(_coreIconButton["default"], {
        id: "".concat(this.props.textInput.id, "-trigger"),
        loading: this.props.state === 'loading',
        srText: (_this$props$searchIco = this.props.searchIconButton) !== null && _this$props$searchIco !== void 0 && _this$props$searchIco.srText ? this.props.searchIconButton.srText : this.props.t('Search'),
        onClick: this.props.handleSubmit,
        size: 4,
        icon: {
          name: 'search'
        }
      })));
    }
  }]);

  return SearchTextInput;
}(_react.PureComponent);

exports["default"] = SearchTextInput;
SearchTextInput.displayName = "SearchTextInput";
//# sourceMappingURL=SearchTextInput.js.map